import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface TenantModuleParameter extends Parameter {
  searchTerm: number;
  orderBy: string;

}
export interface TenantModule {
  id?: string;
  tenantId: string;
  branchId: string;
  moduleId: string;

  parameters?: TenantModuleParameter[];
  links?: any;
}
export abstract class TenantModuleData {
 
    abstract list(url: string): Observable<TenantModule[]>;
  abstract createTenantModule(url: string, data: any[]): Observable<any>;
    abstract update(url: string, data: TenantModule): Observable<any>;
    abstract delete(url: string): Observable<any>;

}
